window.BurnApi = window.BurnApi || {  
  baseUrl: "https://burnproject.herokuapp.com/burn/api/",
  printImageUrl: "https://burnproject.myshopify.com/pages/print-coupon/",
  endpoints: {
    editions: "editions",
    redeem: "redeem",
    print: "print",
    redemptions: "redemptions",
    issue: "issue",
    giftcards: "giftcards",
    search: "search",
    register: "register",
    registration: "registration_custom",
    featured_offers: "featured_offers",
    regcodes: "code_balance",
    geo_location: "geo_location",
    geo_point: "geo_point",
    geo_address: "geo_address",
    log_code: "log_code"
  },
  redirectTocustomCheckout: function() {
    var url = "https://burnproject.herokuapp.com/checkout?" + jQuery.param({
      shop: window.location.hostname,
      customer_id: $("#top_bar_customer_id").val() || ""
    });
    
    window.location.href = url;
  },
  editionIds: [],
  callApi: function (endpoint, params, success_callback, error_callback) {
    var method = "POST";
    
    if (endpoint == BurnApi.endpoints.search) method = "GET";
    
    jQuery.ajax({
      method: method,
      url: BurnApi.baseUrl + endpoint,
      dataType: "json",
      data: params,
      success: function (result) {
        success_callback(result);
      },
      error: function (xhr, status, error) {
        error_callback();
      }
    });
  },
  callEx: function (endpoint, params, success_callback, error_callback) {
    this.getEditions(function (editions) {
      BurnApi.callApi(endpoint, params, success_callback, error_callback);
    });
  },
  getEditions: function (callback) {
    if (this.editionIds.length > 0) {
      callback(this.editionIds);
      return;
    }

    this.callApi(BurnApi.endpoints.editions, {}, function (result) {
      if (result && result.success) {
        BurnApi.editionIds = [];

        jQuery(result.data).each(function () {
          BurnApi.editionIds.push(this.id);
        });
      }

      callback(BurnApi.editionIds);
    }, function () {
      callback([]);
    });
  },
  redeem: function (customer_id, sku, order_id, lineitem_id, order_number, callback) {
    this.callApi(BurnApi.endpoints.redeem, {
      sku: sku,
      editionIds: BurnApi.editionIds,
      customer_id: customer_id,
      order_id: order_id,
      lineitem_id: lineitem_id,
      order_number: order_number
    }, function (result) { callback(result); }, function () { 
      callback({success: false, message: "Oops! Something went wrong."});
    });
  },
  print: function (customer_id, sku, order_id, lineitem_id, order_number, callback) {
    this.callApi(BurnApi.endpoints.print, {
      sku: sku,
      editionIds: BurnApi.editionIds,
      customer_id: customer_id,
      order_id: order_id,
      lineitem_id: lineitem_id,
      order_number: order_number
    }, function (result) { callback(result); }, function () { 
      callback({success: false, message: "Oops! Something went wrong."});
    });
  },
  redemptions: function(lineitem_ids, callback) {
    this.callApi(BurnApi.endpoints.redemptions, {redemption_lineitem_ids: lineitem_ids}, function (result) {
      if (result && result.success) {
        callback(result.data); 
      }
      else {
        callback(null);
      }
    }, function () {
      callback(null);
    });
  },
  issue: function(issue_info, callback) {
    this.callApi(BurnApi.endpoints.issue, {issue_info: issue_info}, function (result) {
      if (result && result.success) {
        callback(true); 
      }
      else {
        callback(false);
      }
    }, function () {
      callback(false);
    });
  },
  giftcards: function(giftcard_ids, callback) {    
    this.callApi(BurnApi.endpoints.giftcards, {giftcard_ids: giftcard_ids}, function (result) {
      if (result && result.success) {
        callback(result.data); 
      }
      else {
        callback(null);
      }
    }, function () {
      callback(null);
    });
  },
  regcodes: function(regcodes, callback) {
    this.callApi(BurnApi.endpoints.regcodes, {access_code: regcodes}, function (result) {
      if (result && result.success) {
        callback(result.data); 
      }
      else {
        callback(null);
      }
    }, function () {
      callback(null);
    });
  },
  search: function(location, lat, lng, filter, keywords, category, radius, pageNum, pageSize, callback) {
    this.callApi(BurnApi.endpoints.search, {
      search_filter: filter,
      search_keywords: keywords,
      search_category: category,
      search_lat: lat,
      search_lng: lng,
      search_radius: radius,
      search_pagesize: pageSize,
      search_pagenum: pageNum
    }, function (result) {
      if (result && result.success) {        
        callback(result.data); 
      }
      else {
        callback(null);
      }
    }, function () {
      callback(null);
    });
  },
  register: function(customer_id, access_code, is_shopify_id, callback) {
    this.callApi(BurnApi.endpoints.register, {
      customer_id: customer_id,
      access_code: access_code,
      is_shopify_id: is_shopify_id
    }, function (result) {
      callback(result);
    }, function () {
      callback(null);
    });
  },
  isRegistration: false,
  registrationCallbacks: [],
  doRegistrationCallback: function(data) {
    jQuery.each(BurnApi.registrationCallbacks, function(index, value) {
      value(data);
    });

    BurnApi.isRegistration = false;
    BurnApi.registrationCallbacks = [];
  },
  registration: function(customer_id, callback) {
    if (BurnApi.isRegistration) {      
      BurnApi.registrationCallbacks.push(callback);
      return;
    }
    
    BurnApi.isRegistration = true;
    
    this.callApi(BurnApi.endpoints.registration, {
      customer_id: customer_id
    }, function (result) {
      var data = null;

      if (result && result.success) {
        callback(result.data);        
        data = result.data;
      }
      else {
        callback(null);
      }

      BurnApi.doRegistrationCallback(data);
    }, function () {
      callback(null);
      BurnApi.doRegistrationCallback(null);
    });
  },
  featured_offers: function(offer_count, geo_metro_code, callback) {    
    this.callApi(BurnApi.endpoints.featured_offers, {
      offer_count: offer_count,
      geo_metro_code: geo_metro_code
    }, function (result) {
      if (result && result.success)
      	callback(result.data);
      else
        callback(null);
    }, function () {
      callback(null);
    });
  },
  geoLocation: function(lat, lng, callback) {    
    this.callApi(BurnApi.endpoints.geo_location, {
      geo_lat: lat,
      geo_lng: lng
    }, function (result) {
      if (result && result.success)
      	callback(result.data);
      else
        callback(null);
    }, function () {
      callback(null);
    });
  },
  geoPoint: function(city, state, zip, description, callback) {    
    this.callApi(BurnApi.endpoints.geo_point, {
      geo_city: city,
      geo_state: state,
      geo_zip: zip,
      geo_description: description
    }, function (result) {
      if (result && result.success)
      	callback(result.data);
      else
        callback(null);
    }, function () {
      callback(null);
    });
  },
  geoAddress: function(city, state, zip, description, callback) {    
    this.callApi(BurnApi.endpoints.geo_address, {
      geo_city: city,
      geo_state: state,
      geo_zip: zip,
      geo_description: description
    }, function (result) {
      if (result && result.success)
      	callback(result.data);
      else
        callback(null);
    }, function () {
      callback(null);
    });
  },
  logCode: function(page, code, callback) {    
    this.callApi(BurnApi.endpoints.log_code, {
      page: page,
      code: code
    }, function (result) {
      if (result && result.success)
      	callback(true);
      else
        callback(false);
    }, function () {
      callback(false);
    });
  }
};